import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { Card, CardContent, CardHeader } from "@mui/material";

import { CompaniesSelector } from "@/pages/banners/admin/CompaniesSelector";
import { UserSafeSenders } from "@/pages/banners/admin/UserSafeSenders";
import { CompanySummary } from "@/pages/banners/remote-apis/bannerUsersApi";

export const BannersAdmin = () => {
  const { t } = useTranslation();
  const [companies, setCompanies] = useState<CompanySummary[]>([]);

  return (
    <Card>
      <CardHeader title={t("Admin")} />
      <CardContent>
        <CompaniesSelector value={companies} onChange={setCompanies} />
        <UserSafeSenders companies={companies} />
      </CardContent>
    </Card>
  );
};
